/*
 *   File : order.js
 *   Author : https://evoqins.com
 *   Description : Order listing page
 *   Integrations : NA
 *   Version : 1.0.0
*/


import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

//custom components
import { DetailPreviewCard, FilterCard, OrderCard } from '../../Component/Cards';
import { BreadCrumbs, CustomTab, EmptyScreen } from '../../Component/Other';
import { Footer } from '../../Component/Footer';
import { APIService } from '../../Service';
import { OffcanvasDetailViewModal, OrderFilterModal } from '../../Component/Modal';
import { Pagination } from '../../Component/Pagination';
import OverLay from '../../Component/Other/overlay';
import { SectionTitle } from '../../Component/Title';
import { Icon } from '../../Component/Icon';

// Assets
import Loader from "../../Assets/Images/coloured_loader.svg";
import EmptyOrder from "../../Assets//Images/EmptyScreen/no-order.webp";
import NextIcon from "../../Assets/Images/right-black-icon.svg";
import { _openOffcanvasModal } from '../../Helper/function';
import { useSelector } from 'react-redux';


const BREADCRUMBS = [
    {
        label: "Home",
        path: "/",

    },
    {
        label: "Orders",
    }
];


const ORDERS_TAB = [
    {
        id: null,
        label: "All"
    },
    {
        id: 1,
        label: "Funds"
    },
    {
        id: 2,
        label: "Goals"
    },
    {
        id: 3,
        label: "Basket"
    },
];

const FILTER_OPTIONS_ORDERS_FOR = [
    {
        id: null,
        label: "All"
    },
    {
        id: -1,
        label: "My orders"
    },
];

const ITEMS_PER_PAGE = 10;

const DEFAULT_FILTER_ORDER_FOR = {
    id: -1,
    label: "My orders"
};

const DEFAULT_FILTER_PAYMENT_STATUS = {
    id: null,
    label: "All"
};

const DEFAULT_FILTER_ORDER_TYPE = {
    id: null,
    label: "All"
};

const OrderListing = () => {

    const location = useLocation();
    const applied_filters = JSON.parse(localStorage.getItem("order_filters"));
    const FILTER_OPTIONS_FAMILY = useSelector(store => store.Reducer.FILTER_OPTIONS_FAMILY);

    const [tabIndex, setTabIndex] = useState(applied_filters && applied_filters?.tab_index ? applied_filters.tab_index : null);
    const [isCardView, setIsCardView] = useState(applied_filters && applied_filters?.is_card_view ? applied_filters.is_card_view : false);
    const [filterOrdersFor, setFilterOrdersFor] = useState(applied_filters && applied_filters?.filter_by_order_for ? applied_filters.filter_by_order_for : DEFAULT_FILTER_ORDER_FOR);
    const [selectedPaymentStatusFilter, setSelectedPaymentStatusFilter] = useState(applied_filters && applied_filters?.filter_by_payment_status ? applied_filters.filter_by_payment_status : DEFAULT_FILTER_PAYMENT_STATUS);
    const [selectedOrderTypeFilter, setSelectedOrderTypeFilter] = useState(applied_filters && applied_filters?.filter_by_order_type ? applied_filters.filter_by_order_type : DEFAULT_FILTER_ORDER_TYPE);
    const [orderData, setOrderData] = useState([]);

    const [pageNumber, setPageNumber] = useState(1);
    const [dataLoading, setDataLoading] = useState(true);
    const [toggleFilter, setToggleFilter] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(0);
    const [totalPage, setTotalPage] = useState(0);

    const [detailDataLoading, setDetailDataLoading] = useState(false);

    const [selectedOrder, setSelectedOrder] = useState({});
    const [orderDetail, setOrderDetail] = useState({});
    const [selectedFundId, setSelectedFundId] = useState("");

    const [filterOptionsOrdersFor, setFilterOptionsOrdersFor] = useState([]);

    // for filters
    useEffect(() => {
        setFilterOptionsOrdersFor([...FILTER_OPTIONS_ORDERS_FOR, ...FILTER_OPTIONS_FAMILY])
    }, [FILTER_OPTIONS_FAMILY]);

    useEffect(() => {
        _getOrderList();
        setDataLoading(true);
        setSelectedOrder({});
        setSelectedFundId("");
        setOrderDetail({});
        setPageNumber(1);

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        // Saving applied filters in localstorage
        localStorage.setItem("order_filters", JSON.stringify({
            "filter_by_payment_status": selectedPaymentStatusFilter,
            "filter_by_order_type": selectedOrderTypeFilter,
            "filter_by_order_for": filterOrdersFor,
            "tab_index": tabIndex,
            "is_card_view": isCardView,
        }));

        let applied_filters = [selectedOrderTypeFilter, selectedPaymentStatusFilter].filter(item => item.id);
        setAppliedFilters(applied_filters.length);

    }, [filterOrdersFor, selectedOrderTypeFilter, selectedPaymentStatusFilter, tabIndex]);

    useEffect(() => {
        _getOrderList();
        setDataLoading(true);
        setSelectedOrder({});
        setSelectedFundId("");
        setOrderDetail({});
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [pageNumber]);


    useEffect(() => {
        // Removing backdrop form UI when user goes back in history while filter modals opened
        window.addEventListener('popstate', function () {
            if (toggleFilter === true) {
                setToggleFilter(false);
            };
        });
    }, [toggleFilter]);

    // Setting active tab and filter - when coming from payment modal
    useEffect(() => {
        if (location.state && location.state.order_id) {
            _getOrderDetail(location.state.order_id);
        }
    }, [location]);


    //handle tab change
    const _handleTabChange = (id) => {
        setTabIndex(id);
        setSelectedOrder({});
        setSelectedFundId("");
        setOrderDetail({});
        setPageNumber(1);
    };

    //handle toggle filter modal
    const _handleToggleFilter = () => {
        setToggleFilter(status => !status);
    };


    //handle filter submit
    const _handleApplyFilter = (filterOrdersFor, selectedOrderType, selectedPaymentStatus) => {
        setFilterOrdersFor(filterOrdersFor);
        setSelectedOrderTypeFilter(selectedOrderType);
        setSelectedPaymentStatusFilter(selectedPaymentStatus);
        setToggleFilter(false);

        let applied_filters = [selectedOrderType, selectedPaymentStatus].filter(item => item.id);
        setAppliedFilters(applied_filters.length);
    };

    const _handleChangeOrdersView = () => {
        setIsCardView(prev => !prev);
    };

    const _handleSelectOrderItem = (selected_order) => {
        if (selectedOrder?.order_id !== selected_order.order_id) {
            setSelectedOrder(selected_order);
            // API call
            setDetailDataLoading(true);
            _getOrderDetail(selected_order.order_id);
        } else {
            if (selectedOrder?.order_id) {
                // Already we have data
                _openOffcanvasModal();
            }
        }
    };

    const _handleShowFundDetail = (id) => {
        if (selectedFundId === id) {
            setSelectedFundId("");
        } else {
            setSelectedFundId(id);
        }
    };

    // handle order listing pagination change
    const _handlePagination = (new_start_limit) => {
        const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
        setPageNumber(selected_page);
    };


    /* ===============================================
                     API CALLS
  ================================================ */

    //API- Post order list 
    const _getOrderList = () => {
        let api_version = 2;
        let is_post = true;
        let url = 'order/list';
        let data = {
            "page_num": pageNumber,
            "page_size": ITEMS_PER_PAGE,
            "investment_type": tabIndex,
            "family_detail_id": filterOrdersFor?.id,
            "payment_status": selectedPaymentStatusFilter?.id,
            "type": selectedOrderTypeFilter?.id,
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setOrderData((response.data.orders || []));
                setTotalPage(response.data.total_pages);

                if (location.state && location.state.order_id) {
                    let selected_order = response.data.orders.find(order => order.order_id === location.state.order_id);
                    setSelectedOrder(selected_order || {});
                }
            } else {
                setOrderData([]);
            };
            setDataLoading(false);
        });
    };

    //API- Post order detail 
    const _getOrderDetail = (order_id) => {
        let api_version = 2;
        let is_post = true;
        let url = 'order/detail';
        let data = {
            "order_id": order_id,
        };

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200) {
                setOrderDetail(response.data);

                // Scrolling to view
                if (document.querySelector("#detailed-fund-view")) {
                    let detailed_card_wrapper = document.querySelector("#detailed-fund-view");
                    detailed_card_wrapper.scrollIntoView({ behavior: "smooth", block: "start" })
                }

                if (window.innerWidth < 768) {
                    _openOffcanvasModal();
                }

            } else {
                setOrderDetail({});
                setSelectedOrder({});
                toast.dismiss();
                toast.error(response.message);
            };
            setDetailDataLoading(false);
        });
    };


    // *********** Inner Components ***************//
    const TimelineCard = ({ data, dataLength, index, type }) => {
        return (
            <div className='d-flex flex-column align-items-start' key={index}>
                <div className="d-flex gap-12px align-items-center">
                    {
                        type === 1 ?

                            <Icon icon={data.status === "FAILED" ? "status-failed" : data.status === "SUCCESS" ? "status-success" : "status-pending"}
                                className="w-32px width-24px-res" />
                            :
                            <Icon icon={data.status === "failed" ? "status-failed" : data.status === "success" ? "status-success" : "status-pending"}
                                className="w-32px width-24px-res" />

                    }
                    <div>
                        <p className={`d-flex align-items-center gap-1 e-text-onyx e-font-12-res e-font-14 e-primary-font-inter e-font-weight-400 line-height-20px mb-0`}>
                            {data.label || data.amount_text}
                        </p>
                        <span className='e-text-bold-grey e-font-10-res e-font-12 e-primary-font-inter e-font-weight-400 line-height-14px'>
                            {data.value || data.date}
                        </span>
                    </div>
                </div>
                {
                    dataLength > 1 && index !== dataLength - 1 &&
                    <img src={require("../../Assets/Images/vertical-dashed-line.svg").default}
                        className="object-fit-contain img-fluid margin-10px-start-res ms-sm-3 margin-4px-bottom"
                        draggable="false"
                        alt="vertical-dashed-line" />
                }
            </div>
        )
    };

    const DetailsViewCard = () => {
        return (
            <>
                {
                    detailDataLoading ?
                        <div className="e-border-1px-white-marble e-border-radius-24 p-3 pt-5 text-center pb-5" >
                            <img src={Loader}
                                draggable="false"
                                alt="loader" />
                        </div>
                        :
                        selectedOrder.name ?
                            // Fund Details
                            orderDetail?.summary?.basket_order === false && orderDetail?.summary?.is_goal === false ?
                                <div className="e-border-1px-white-marble e-border-radius-24">
                                    <div className="e-bg-cultured e-border-radius-16 p-2 m-3">
                                        <div className={`d-flex gap-2`}>
                                            <img src={orderDetail.funds?.icon}
                                                width={32}
                                                height={32}
                                                className="object-fit-contain e-border-radius-8 e-bg-white p-1"
                                                draggable="false"
                                                alt="fund image" />
                                            <h3 className="e-ellipse e-text-charleston-green e-font-10 e-alt-font-poppins e-font-weight-400 line-height-14px margin-12px-bottom mb-0">
                                                {orderDetail.funds?.fund_name}
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="p-3 pt-0 e-border-bottom-1px-sparkling-silver">
                                        <div className="d-flex justify-content-between margin-12px-bottom">
                                            <div className="col-auto d-flex flex-column">
                                                <span className="e-text-dark-heather  e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    Folio no
                                                </span>
                                                <span className=" e-text-chinese-black e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                    {orderDetail.funds?.folio_no}
                                                </span>
                                            </div>
                                            <div className="col-auto d-flex flex-column text-end">

                                                <span className="e-text-dark-heather  e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    Order ID
                                                </span>
                                                <span className=" e-text-chinese-black e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                    {orderDetail.funds?.order_detail_id}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between margin-12px-bottom">
                                            <div className="col-auto d-flex flex-column">
                                                <span className="e-text-dark-heather  e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    NAV
                                                </span>
                                                <span className=" e-text-chinese-black e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                    {orderDetail.funds?.nav_value_text || "-"}
                                                </span>
                                            </div>
                                            <div className="col-auto d-flex flex-column text-end">
                                                <span className="e-text-dark-heather  e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    Units
                                                </span>
                                                <span className=" e-text-chinese-black e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                    {orderDetail.funds?.units || "-"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <div className="col-auto d-flex flex-column">
                                                <span className="e-text-dark-heather  e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    NAV date
                                                </span>
                                                <span className=" e-text-chinese-black e-font-14 e-font-12-res e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                    {orderDetail.funds?.nav_date || "-"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Transaction status */}
                                    <div className="p-3">
                                        <SectionTitle title="Transaction status"
                                            fontFamily="e-primary-font-inter  e-text-eerie-black mb-3"
                                            fontSize="e-font-14" />

                                        {
                                            (orderDetail.funds.order_timeline || []).map((item, index) => (
                                                <TimelineCard type={1}
                                                    data={item}
                                                    index={index}
                                                    dataLength={orderDetail.funds.order_timeline.length} />
                                            ))
                                        }

                                        {
                                            orderDetail.summary?.failure_reason ?
                                                <p className='mt-3 e-bg-calming-baby-pink-60  e-border-radius-4  px-2 py-1 mb-0 e-text-charleston-green e-font-10 e-primary-font-inter  e-font-weight-400 line-height-16px'>
                                                    {orderDetail.summary?.failure_reason}
                                                </p>
                                                :
                                                ""
                                        }


                                    </div>

                                    {/* Previous SIP installments */}
                                    {
                                        (orderDetail.sip_instalments && orderDetail.sip_instalments?.length) > 0 &&
                                        <div className="p-3  e-border-top-1px-sparkling-silver e-border-bottom-1px-sparkling-silver">
                                            <SectionTitle title="Previous SIP installments"
                                                fontFamily="e-primary-font-inter  e-text-eerie-black mb-3"
                                                fontSize="e-font-14" />
                                            {
                                                (orderDetail.sip_instalments || []).map((item, index) => (
                                                    <TimelineCard type={2}
                                                        data={item}
                                                        index={index}
                                                        dataLength={orderDetail.sip_instalments.length} />
                                                ))
                                            }
                                        </div>
                                    }
                                </div>
                                :
                                // Goal and Basket Details
                                <div className="e-border-1px-white-marble e-border-radius-24">
                                    <div className="e-bg-cultured e-border-radius-16 p-2 m-3">
                                        <div className={`d-flex gap-2 align-items-center`}>
                                            <img src={orderDetail.summary?.icon}
                                                width={32}
                                                height={32}
                                                className="object-fit-contain e-border-radius-8 e-bg-white p-1"
                                                draggable="false"
                                                alt="fund image" />
                                            <h3 className="e-ellipse e-text-charleston-green e-font-10 e-alt-font-poppins e-font-weight-400 line-height-14px margin-12px-bottom mb-0">
                                                {orderDetail.summary?.name}
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="p-3 pt-0 e-border-bottom-1px-sparkling-silver">
                                        <div className="d-flex justify-content-between margin-12px-bottom">
                                            <div className="col-auto d-flex flex-column">
                                                <span className="e-text-dark-heather  e-font-14 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    Date
                                                </span>
                                                <span className=" e-text-chinese-black e-font-14 e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                    {orderDetail.summary?.order_date}
                                                </span>
                                            </div>
                                            <div className="col-auto d-flex flex-column text-end">

                                                <span className="e-text-dark-heather  e-font-14 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    Order ID
                                                </span>
                                                <span className=" e-text-chinese-black e-font-14 e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                    {orderDetail.summary?.order_id}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <div className="col-auto d-flex flex-column">
                                                <span className="e-text-dark-heather  e-font-14 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    Payment status
                                                </span>
                                                <span className={`${orderDetail.summary?.payment_status === "Failed" ? 'e-text-sunset-orange' : orderDetail.summary?.payment_status === "Pending" ? "e-text-mustard-yellow" : 'e-text-bottle-green'} mb-0 e-font-14 e-primary-font-inter  e-font-weight-600 line-height-22px`}>
                                                    {orderDetail.summary?.payment_status}
                                                </span>
                                            </div>
                                            <div className="col-auto d-flex flex-column text-end">
                                                <span className="e-text-dark-heather  e-font-14 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                    Order status
                                                </span>
                                                <span className={`${orderDetail.summary?.order_status === "Failed" ? 'e-text-sunset-orange' : orderDetail.summary?.order_status === "Pending" ? "e-text-mustard-yellow" : 'e-text-bottle-green'} mb-0 e-font-14 e-primary-font-inter  e-font-weight-600 line-height-22px`}>
                                                    {orderDetail.summary?.order_status}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <SectionTitle title="Fund details"
                                            fontFamily="e-primary-font-inter  e-text-eerie-black px-3 pt-3"
                                            fontSize="e-font-14" />

                                        {
                                            (orderDetail.funds || []).map((fund, index) => (
                                                <div className={`px-3 pb-3 padding-12px-top`} key={index}>
                                                    <div className="d-flex gap-1 align-items-center cursor-pointer" onClick={() => _handleShowFundDetail(fund.order_detail_id)}>
                                                        <img src={fund.icon}
                                                            width={32}
                                                            height={32}
                                                            className="object-fit-contain e-border-radius-8 e-bg-white p-1"
                                                            draggable="false"
                                                            alt="fund image" />
                                                        <h6 className="e-ellipse flex-fill e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-400 line-height-20px mb-0">
                                                            {fund.fund_name}
                                                        </h6>
                                                        <Icon icon={"arrow-right-allocation"}
                                                            className={`${selectedFundId === fund.order_detail_id ? "transform-rotate-min-90" : "transform-rotate-90"} ms-auto transition`}
                                                            size={16} />
                                                    </div>

                                                    {
                                                        selectedFundId === fund.order_detail_id &&
                                                        <>
                                                            <div className="d-flex justify-content-between margin-12px-bottom margin-12px-top">
                                                                <div className="col-auto d-flex flex-column">
                                                                    <span className="e-text-dark-heather  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                                        Amount
                                                                    </span>
                                                                    <span className=" e-text-chinese-black e-font-12 e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                                        {fund.amount_text}
                                                                    </span>
                                                                </div>
                                                                <div className="col-auto d-flex flex-column text-end">

                                                                    <span className="e-text-dark-heather  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                                        Units
                                                                    </span>
                                                                    <span className=" e-text-chinese-black e-font-12 e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                                        {fund.units}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-between e-border-bottom-1px-sparkling-silver padding-12px-bottom margin-12px-bottom">
                                                                <div className="col-auto d-flex flex-column">
                                                                    <span className="e-text-dark-heather  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                                        Allocation date
                                                                    </span>
                                                                    <span className=" e-text-chinese-black e-font-12 e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                                        {fund.allocation_date || "-"}
                                                                    </span>
                                                                </div>
                                                                <div className="col-auto d-flex flex-column text-end">
                                                                    <span className="e-text-dark-heather  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-22px">
                                                                        Transaction ID
                                                                    </span>
                                                                    <span className=" e-text-chinese-black e-font-12 e-alt-font-poppins e-font-weight-500 line-height-22px">
                                                                        {fund.transaction_id || "-"}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {/* Transaction status */}
                                                            <div>
                                                                <SectionTitle title="Transaction status"
                                                                    fontFamily="e-primary-font-inter  e-text-eerie-black mb-3"
                                                                    fontSize="e-font-14" />

                                                                {
                                                                    (fund.order_timeline || []).map((item, index) => (
                                                                        <TimelineCard type={1}
                                                                            data={item}
                                                                            index={index}
                                                                            dataLength={fund.order_timeline.length} />
                                                                    ))
                                                                }

                                                                {
                                                                    orderDetail.summary?.failure_reason ?
                                                                        <p className='mt-3 e-bg-calming-baby-pink-60  e-border-radius-4  px-2 py-1 mb-0 e-text-charleston-green e-font-10 e-primary-font-inter  e-font-weight-400 line-height-16px'>
                                                                            {orderDetail.summary?.failure_reason}
                                                                        </p>
                                                                        :
                                                                        ""
                                                                }

                                                            </div>


                                                        </>
                                                    }
                                                </div>
                                            ))
                                        }

                                    </div>

                                    {/* Previous SIP installments */}
                                    <div className='e-border-top-1px-sparkling-silver'>
                                        {
                                            (orderDetail.sip_instalments && orderDetail.sip_instalments?.length) > 0 &&
                                            <div className="padding-12px-top px-3 pb-3">
                                                <SectionTitle title="Previous SIP installments"
                                                    fontFamily="e-primary-font-inter  e-text-eerie-black mb-3"
                                                    fontSize="e-font-14" />
                                                {
                                                    (orderDetail.sip_instalments || []).map((item, index) => (
                                                        <TimelineCard type={2}
                                                            data={item}
                                                            index={index}
                                                            dataLength={orderDetail.sip_instalments.length} />
                                                    ))
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            :
                            <DetailPreviewCard title={"Pick an Order to get started"}
                                description=" Detailed insights will appear here once you choose a order." />
                }
            </>
        )
    };

    return (
        <>
            <div className="min-h-100vh pb-4 pb-sm-5 flex-column row e-bg-lotion px-4 px-sm-5 ps-lg-4 pe-lg-0 pt-4 e-border-radius-TL-BL-24px pb-5">
                {/* breadcrumbs */}
                <div className='col-lg-11 px-0'>
                    <div className="row justify-content-between margin-32px-bottom">
                        <div className="col-md-8">
                            <div className="d-flex justify-content-between">
                                <BreadCrumbs data={BREADCRUMBS} />

                                <div className={`position-relative ${dataLoading ? "pe-none opacity-50" : ""}`} id="orders-filter">
                                    <FilterCard filterText={`${filterOrdersFor.label} ${appliedFilters ? `+${appliedFilters}` : ""}`}
                                        handleOpenFilterModal={_handleToggleFilter} />
                                    {
                                        toggleFilter &&
                                        <>
                                            <OverLay isOpen={toggleFilter} onClose={_handleToggleFilter} />
                                            <OrderFilterModal
                                                filterOptionsOrdersFor={filterOptionsOrdersFor}
                                                selectedFilterOrdersFor={filterOrdersFor}
                                                selectedPaymentStatus={selectedPaymentStatusFilter}
                                                selectedOrderType={selectedOrderTypeFilter}
                                                handleApplyFilter={_handleApplyFilter}
                                                handleCancelFilter={_handleToggleFilter} />
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row row-gap-4 ">
                        <div className="col-md-8">
                            <div className="d-flex justify-content-between mb-4">
                                {
                                    ORDERS_TAB.map((data, key) => (
                                        <CustomTab key={key}
                                            className="flex-fill text-center"
                                            type={4}
                                            tabData={data}
                                            tabIndex={tabIndex}
                                            handleChange={_handleTabChange} />
                                    ))
                                }
                            </div>
                            <div className='d-flex justify-content-between align-items-center mb-sm-4 mb-3'>
                                <SectionTitle title={"All orders"}
                                    fontFamily=" e-primary-font-inter e-text-eerie-black e-font-20" />

                                <Icon icon={isCardView ? "list-view" : "card-view"}
                                    className="cursor-pointer w-24px width-16px-res"
                                    onClick={_handleChangeOrdersView} />
                            </div>

                            <div className={`row ${isCardView ? "row-gap-sm-4 row-gap-3" : "row-gap-3"}`}>
                                {
                                    dataLoading ?
                                        <div className="text-center mt-5 min-vh-100" >
                                            <img src={Loader}
                                                draggable="false"
                                                alt="loader" />
                                        </div>
                                        :
                                        <>
                                            {
                                                orderData.length !== 0 ? (
                                                    orderData.map((data, key) => (
                                                        <>
                                                            <div className={`${isCardView ? "col-12 col-sm-6" : "col-12"} `} key={key}>
                                                                <OrderCard data={data}
                                                                    isCardView={isCardView}
                                                                    fundType={tabIndex}
                                                                    selected={selectedOrder}
                                                                    onClickCard={() => _handleSelectOrderItem(data)} />
                                                            </div>
                                                        </>
                                                    ))
                                                ) : (

                                                    <EmptyScreen
                                                        img={EmptyOrder}
                                                        title="No order yet !"
                                                        description="Currently, there are no orders to show. Start exploring our products." />
                                                )
                                            }
                                        </>
                                }

                            </div>


                            {
                                orderData.length !== 0 && totalPage > 1 &&
                                <div className="e-display-flex justify-content-center e-gap-0-16 pt-4 mt-2 " >
                                    <Pagination
                                        initialPage={pageNumber - 1}
                                        nextButtonLabel={<img src={NextIcon} draggable="false" alt="Next" />}
                                        prevButtonLabel={<img src={NextIcon} draggable="false" alt="Next" />}
                                        itemsPerPage={ITEMS_PER_PAGE}
                                        totalPage={totalPage}
                                        onChange={_handlePagination}
                                        showFirstLastPages={true} />
                                </div >
                            }

                        </div>
                        <div className="col-md-4 d-md-block d-none" id='detailed-fund-view'>
                            <DetailsViewCard />
                        </div>
                    </div>
                </div>
            </div >

            {/* footer */}
            < Footer />

            {
                selectedOrder?.order_id &&
                <OffcanvasDetailViewModal title="Order Detail">
                    <DetailsViewCard />
                </OffcanvasDetailViewModal>
            }
        </>
    )
}

export default OrderListing;


